import { render, staticRenderFns } from "./GoalTracking.vue?vue&type=template&id=03a35bb0&"
import script from "./GoalTracking.vue?vue&type=script&lang=ts&"
export * from "./GoalTracking.vue?vue&type=script&lang=ts&"
import style0 from "./GoalTracking.vue?vue&type=style&index=0&id=03a35bb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports